import React, { useState } from "react"
import { Card, Button, CardBody, Row, Col } from "reactstrap"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { LargeModal } from "components/Common/LargeModal"
import { cardsData, getData } from "./data.js"
import * as moment from "moment"
import TableLoader from "../../../components/Common/TableLoader"
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css"
import axios from "axios"
import { API_URL } from "constants/constants.js"

function Table(props) {
  const [isOpen, setIsOpen] = useState(false)

  let { data, total } = props

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "name",
      text: "Game",
      sort: true,
    },
    {
      dataField: "category",
      text: "Category",
      sort: true,
    },
    {
      dataField: "unique_players",
      text: "Unique Players",
      sort: true,
    },
    {
      dataField: "bets",
      text: "Bets",
      sort: true,
      formatter: (cell, row) => <>{Number(row.bets).toLocaleString("en-GB")}</>,
    },
    {
      dataField: "total_stake",
      text: "Total Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.total_stake.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "stake_tax",
      text: "Stake Tax",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row?.stake_tax?.toFixed(2) ?? 0).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "total_stake",
      text: "Actual Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.total_stake.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "bonus",
      text: "Bonus",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.bonus ?? 0).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row?.wht ?? 0)?.toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
    {
      dataField: "payout",
      text: "NetWin",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.payout.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "GGR",
      text: "GGR",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.GGR.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "GGR_ratio",
      text: "GGR Ratio",
      sort: true,
      formatter: (cell, row) => {
        const ggrRatioValue = Number(row.GGR_ratio.toFixed(2))
        const style = {
          color:
            ggrRatioValue > 0 ? "green" : ggrRatioValue < 0 ? "red" : "inherit",
          fontWeight: "bold",
        }

        return (
          <span style={style}>{ggrRatioValue.toLocaleString("en-GB")}</span>
        )
      },
    },
  ]
  const modalColumns = [
    {
      dataField: "Time",
      text: "Time",
    },
    {
      dataField: "Event",
      text: "Event",
    },
    {
      dataField: "Type",
      text: "Type",
    },
    {
      dataField: "Outcome",
      text: "Outcome",
    },
    {
      dataField: "Price",
      text: "Price",
    },
    {
      isDummyField: true,
      text: "Status",
      formatter: (cellContent, row) => (
        <>
          <Button
            type="button"
            color={`${row.Status == "Win" ? "success" : "danger"}`}
            className="btn-sm"
          >
            {row.Status}
          </Button>
        </>
      ),
    },
  ]

  const modalData = [
    {
      Time: "14/04/2021 22:00:00",
      Price: "$100",
      Type: "Pre-Match",
      Event: "Paris Saint-Germain FC vs. AS Saint-Etienne",
      OutCome: "1x2-PSG",
      Odds: "1.33",
      Outcome: "PSG",
      Status: "Win",
    },
    {
      Time: "14/04/2021 22:00:00",
      Price: "$100",
      Type: "Pre-Match",
      Event: "Paris Saint-Germain FC vs. AS Saint-Etienne",
      OutCome: "1x2-PSG",
      Odds: "1.33",
      Outcome: "PSG",
      Status: "Lost",
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { SearchBar } = Search
  //pagination customization
  const { ExportCSVButton } = CSVExport

  const pagination = paginationFactory({
    // page: props?.currentPage,
    sizePerPage: 100,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    // showTotal: true,
    // totalSize: data.length,
    alwaysShowAllBtns: true,
    totalSize: total,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    // custom: true,
  })
  const rowEvents = {
    // onClick: (e, row, rowIndex) => {
    //   setIsOpen(true)
    // },
  }
  const MyExportCSV = toolkitProps => {
    const handleClick = () => {
      props.setLoadingMessage("1")
      axios({
        method: "get",
        url: `${API_URL}/admin/reports/game-reports?to=${props.toDate}&from=${
          props.fromDate
        }&type=${props.item}&item=${props.type}&unsetPagination=${true}`,
      })
        .then(function (response) {
          toolkitProps.onExport(response?.data?.data)
          props.setLoadingMessage("0")
        })
        .catch(function (response) {})
    }
    return (
      <div>
        <button className="btn btn-primary" onClick={handleClick}>
          Download
        </button>
      </div>
    )
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Games Reports"}</div>
          {props.loadingMessage && props.loadingMessage == "1" ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={pagination}
              keyField="id"
              columns={columns}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  bootstrap4
                  search
                  exportCSV={{
                    onlyExportFiltered: true,
                    exportAll: false,
                    fileName: `Games-Report-${moment(new Date()).format(
                      "DD/MM/YYYY"
                    )}.csv`,
                  }}
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="6">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                            <Col sm="6">
                              <div>
                                <MyExportCSV {...toolkitProps.csvProps} />
                                {/*<ExportCSVButton { ...toolkitProps.csvProps } className="download-table-xls-button w-md btn btn-primary">Download</ExportCSVButton>*/}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={6}></Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              id="table-to-xls"
                              keyField="id"
                              data={data}
                              columns={columns}
                              pagination={pagination}
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              //   selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                              rowEvents={rowEvents}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="" id="pagination-id"></div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
      <LargeModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        cardsData={cardsData}
        betType={"1bet, 2-fold multiple"}
        size={"xl"}
        columns={modalColumns}
        data={modalData}
      />
    </>
  )
}
export default Table
